import { TemplateVersion } from './../../../shared/dtos/template-version';
import { itiMessageService, itiPermissionService, itiTokenService } from '@/iti-core-vue';
import templatesModule from '@/store/modules/templates.module';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { validate, ValidationProvider } from 'vee-validate';
import { Field } from '@/shared/dtos/field';
import { ItiIconButton, ItiVHeader } from '@/iti-core-vuetify';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxButton from 'devextreme-vue/button';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import DxCheckBox from 'devextreme-vue/check-box';
import { DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling } from 'devextreme-vue/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import DxValidationSummary from 'devextreme-vue/validation-summary';
import {
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxStringLengthRule,
} from 'devextreme-vue/validator';
import { FormattedCategory } from '@/shared/dtos/formatted-category';
import { Permission } from '@/shared/permissions';

@Component({
    components: {
        ValidationProvider,
        ItiIconButton,
        DxSelectBox,
        DxTextBox,
        DxNumberBox,
        DxTextArea,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxCompareRule,
        DxStringLengthRule,
        DxValidationSummary,
        DxDropDownBox,
        DxTreeView,
        DxCheckBox,
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxFilterRow,
        DxScrolling
    },
})

export default class PlantillaFormulario extends Vue {
    @Prop() id !: number;
    public loading = false;
    public search = "";
    public treeBoxValue: any = null;
    public beforeTreeBoxValue: any = null;
    public treeViewName = 'tree-view';
    public selectedCategory = new FormattedCategory();
    public categoriesDescription = "";
    public offerOrDemand = "";



    public get headers() {
        return [
            new ItiVHeader('description', 'versiones.descripcion'),
            new ItiVHeader('version', 'versiones.version'),
            new ItiVHeader('active', 'versiones.activo'),
            new ItiVHeader('published', 'versiones.publicado').withWidth(300),
            new ItiVHeader('action', '').withWidth(50),
        ];
    }

    public get editTemplate() {
        if (!templatesModule.selectedTemplate.offer) templatesModule.selectedTemplate.offer = false;
        if (!templatesModule.selectedTemplate.demand) templatesModule.selectedTemplate.demand = false;
        return templatesModule.selectedTemplate;
    }


    public get versions() {
        return this.editTemplate.templateVersions;
    }

    public get categories() {
        return templatesModule.formattedCategoriesList;
    }

    public get fields() {
        return templatesModule.templateFields;
    }

    public get templateEditMode() {
        return templatesModule.templateEditMode;
    }

    public get templateTitle() {
        if (templatesModule.selectedTemplate.title == null || templatesModule.selectedTemplate.title.length == 0) {
            return this.$t('plantillas.nuevaPlantilla');
        } else {
            return templatesModule.selectedTemplate.title;
        }
    }

    public get hasPermission() {
        return itiPermissionService.hasPermission(Permission.updateTemplates);
    }

    public created() {
        if (!isNaN(this.id) && this.id != 0) {
            templatesModule.getTemplateById(this.id).then(() => {
                this.assignCategoryDescriptionsToLabel();
                this.assignOfferOrDemandToLabel();
            });
            templatesModule.setTemplateEditMode(true);
        }
    }

    public editVersion(templateVersion: TemplateVersion) {
        templatesModule.getTemplateVersionById(templateVersion.id);
        this.$router.push({ name: 'VersionFormulario', params: { idPlantilla: templateVersion.templateId.toString(), idVersion: templateVersion.id.toString() } })
    }

    public exploreVersion(templateVersion: TemplateVersion) {
        templatesModule.getTemplateVersionById(templateVersion.id);
        this.$router.push({ name: 'ExplorarVersion', params: { idPlantilla: templateVersion.templateId.toString(), idVersion: templateVersion.id.toString() } })
    }

    public publishVersion(templateVersion: TemplateVersion) {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-publicar-version'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                templatesModule.publishVersion(templateVersion).then(() => {
                    templatesModule.getTemplateById(this.id).then();
                    itiMessageService.toast(this.$tc('mensajes-plantillas.ok'), 'success', 2000);
                }).catch(() => {
                    itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
                });
            }
        });
    }

    public activate(templateVersion: TemplateVersion) {
        if (!templateVersion.active && templatesModule.selectedTemplate.templateVersions.length > 1) {
            itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-activar-version'), this.$tc('mensajes.confirmar'), (res) => {
                if (res) {
                    this.activateAction(templateVersion);
                }
            });
        } else {
            this.activateAction(templateVersion);
        }
    }

    private activateAction(templateVersion: TemplateVersion) {
        templatesModule.activate(templateVersion).then(() => {
            templatesModule.getTemplateById(this.id).then();
            itiMessageService.toast(this.$tc('mensajes-plantillas.ok'), 'success', 20000);
        }).catch(() => {
            itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 20000);
        });
    }

    public cloneVersion(templateVersion: TemplateVersion) {
        templatesModule.cloneVersion(templateVersion).then(() => {
            templatesModule.getTemplateById(this.id).then();
            itiMessageService.toast(this.$tc('mensajes-plantillas.ok'), 'success', 20000);
        }).catch(() => {
            itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 20000);
        });
    }

    public mounted() {
        templatesModule.getFormattedCategories();
    }

    public async saveTemplate() {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-guardar'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                // this.assignCategoryToTemplate();
                this.assignOfferOrDemandToLabel();
                templatesModule.saveTemplate(this.editTemplate)
                    .then(async () => {
                        await templatesModule.getTemplateById(this.editTemplate.id);
                        this.assignCategoryDescriptionsToLabel();
                        if (this.id == 0) this.$router.push({ name: 'PlantillaFormulario', params: { id: templatesModule.selectedTemplate.id.toString() } });
                        templatesModule.setTemplateEditMode(true);
                        itiMessageService.toast(this.$tc('mensajes-plantillas.ok'), 'success', 3000);
                        this.$router.back();
                    })
                    .catch(() => {
                        itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
                    });
            }
        });
    }

    public cancelTemplate() {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-salir'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                // if (this.editTemplate.version != null) {
                templatesModule.getTemplateById(templatesModule.selectedTemplate.id);
                this.treeBoxValue = this.beforeTreeBoxValue;
                templatesModule.setTemplateEditMode(true);
                // } else {
                //     this.$router.push({ name: 'ListaPlantillas' });
                // }
            }
        });
    }

    // public assignCategoryToTemplate() {
    //     if (!this.editTemplate.categories) {
    //         this.editTemplate.categories = new Categories();
    //         this.editTemplate.categories.id = 0;
    //     }

    //     switch (this.selectedCategory.level) {
    //         case 1: {
    //             this.editTemplate.categoriesCategoryFirstLevelId = this.selectedCategory.id;
    //             this.editTemplate.categoriesCategorySecondLevelId = 0;
    //             this.editTemplate.categoriesCategoryThirdLevelId = 0;
    //             this.editTemplate.categoriesCategoryFourthLevelId = 0;
    //             break;
    //         }
    //         case 2: {
    //             this.editTemplate.categoriesCategorySecondLevelId = this.selectedCategory.id;
    //             this.editTemplate.categoriesCategoryThirdLevelId = 0;
    //             this.editTemplate.categoriesCategoryFourthLevelId = 0;
    //             break;
    //         }
    //         case 3: {
    //             this.editTemplate.categoriesCategoryThirdLevelId = this.selectedCategory.id;
    //             this.editTemplate.categoriesCategoryFourthLevelId = 0;
    //             break;
    //         }
    //         case 4: {
    //             this.editTemplate.categoriesCategoryFourthLevelId = this.selectedCategory.id;
    //             break;
    //         }
    //     }
    // }

    public async assignOfferOrDemandToLabel() {
        this.offerOrDemand = "";
        if (this.editTemplate.offer) {
            this.offerOrDemand = this.$tc('plantillas.oferta');
            if (this.editTemplate.demand) {
                this.offerOrDemand = this.offerOrDemand + ", " + this.$tc('plantillas.demanda');
            }
        } else if (this.editTemplate.demand) {
            this.offerOrDemand = this.$tc('plantillas.demanda');
        }
    }
    public async assignCategoryDescriptionsToLabel() {
        if (this.editTemplate.categories.categoryFourthLevelId != null) {
            this.categoriesDescription = this.editTemplate.categories.categoryFirstLevelDescription + " - " + this.editTemplate.categories.categorySecondLevelDescription + " - "
                + this.editTemplate.categories.categoryThirdLevelDescription + " - " + this.editTemplate.categories.categoryFourthLevelDescription;
            this.treeBoxValue = "4_" + this.editTemplate.categories.categoryFourthLevelId;
        } else if (this.editTemplate.categories.categoryThirdLevelId != null) {
            this.categoriesDescription = this.editTemplate.categories.categoryFirstLevelDescription + " - " + this.editTemplate.categories.categorySecondLevelDescription + " - "
                + this.editTemplate.categories.categoryThirdLevelDescription;
            this.treeBoxValue = "3_" + this.editTemplate.categories.categoryThirdLevelId;
        } else if (this.editTemplate.categories.categorySecondLevelId != null) {
            this.categoriesDescription = this.editTemplate.categories.categoryFirstLevelDescription + " - " + this.editTemplate.categories.categorySecondLevelDescription;
            this.treeBoxValue = "2_" + this.editTemplate.categories.categorySecondLevelId;
        } else if (this.editTemplate.categories.categoryFirstLevelId != null) {
            this.categoriesDescription = this.editTemplate.categories.categoryFirstLevelDescription;
            this.treeBoxValue = "1_" + this.editTemplate.categories.categoryFirstLevelId;
        }
        this.showSelectedCategoryExpanded();
    }

    public editTemplateParams() {
        templatesModule.getTemplateById(templatesModule.selectedTemplate.id);
        templatesModule.setTemplateEditMode(false);
        this.beforeTreeBoxValue = this.treeBoxValue;
    }

    // public async createNewField() {
    //     templatesModule.newField();
    //     if ((!isNaN(templatesModule.selectedTemplate.id) && templatesModule.selectedTemplate.id != 0)) {
    //         this.$router.push({ name: 'NuevoCampoFormulario', params: { idTemplate: this.id.toString(), idField: '0' } });
    //     } else {
    //         this.$router.push({ name: 'NuevoCampoFormulario', params: { idTemplate: '0', idField: '0' } });
    //     }
    // }

    public async createNewVersion() {
        templatesModule.newTemplateVersion();
        this.$router.push({ name: 'VersionFormulario', params: { idPlantilla: this.id.toString(), idVersion: "0" } });
    }

    public async deleteVersion(version: TemplateVersion) {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-borrar-version'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                templatesModule.deleteTemplateVersion(version).then(() => {
                    itiMessageService.toast(this.$tc('mensajes-plantillas.info-eliminar'), 'success', 3000);
                    // this.editTemplate.templateVersions = templatesModule.selectedTemplate.templateVersions;
                    templatesModule.getTemplateById(this.id).then();
                })
                    .catch(() => {
                        itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
                    });
            }
        });
    }

    // public editFieldParams(field: Field) {
    //     templatesModule.setFieldToEdit(field);
    //     if (field.id) {
    //         this.$router.push({ name: 'NuevoCampoFormulario', params: { idTemplate: templatesModule.selectedTemplate.id.toString(), idField: field.id.toString() } });
    //     } else {
    //         this.$router.push({ name: 'NuevoCampoFormulario' });
    //     }
    // }

    public formattedContent(contenido: string) {
        if (contenido && contenido.length > 40) {
            return String(contenido).substring(0, 40) + "...";
        } else {
            return contenido;
        }
    }

    public goToListCategories() {
        this.$router.push({ name: 'ListaPlantillas' });
    }

    public treeView_itemSelectionChanged(e: any) {
        this.treeBoxValue = e.component.getSelectedNodeKeys();
    }

    public onTreeItemClick(e: any) {
        this.selectedCategory = e.itemData;
    }

    public showSelectedCategoryExpanded() {
        this.categories.forEach(element => {
            if (element.categoryId == this.treeBoxValue) {
                element.expanded = true;
                return;
            }
        });
    }

    public translateState(active: boolean) {
        if (active != null)
            return this.$tc(active.toString());
    }

}